<template>
  <div class="memoryMerge">
    <el-dialog :visible.sync="mergeVisible" center :show-close="false" custom-class=" popupBox"
               :before-close="handleClose">
      <!-- 顶部标题 -->
      <DialogsHeader
                     :title="bankType==='memory'?$t('memoryBankV2.mergememoryBank'):$t('termBankV2.mergeTermBank')" />
      <div class="memoryMerge_content">
        <!--下拉框和搜索框  -->
        <div class="memoryMerge_content_top">
          <div class="top_left">
            <div class="language">
              <p>{{ $t("memoryBankV2.languageDirection") }}</p>
              <el-select v-model="formLabelAlign.lang_desc"
                         :placeholder="$t('memoryBankV2.pleaseChoose')" @change="changeLanguage"
                         clearable @clear="clearLanguage">
                <el-option v-for="(item, index) in languageTwain" :key="index" :label="
                    $i18n.locale === 'zh'
                      ? item.langDesc.replace('>',' — ')
                      : $langCase[item.sourceLang] +
                        ' — ' +
                        $langCase[item.targetLang]
                  " :value="item.langDesc"></el-option>
              </el-select>
            </div>
            <div class="territory">
              <p>{{ $t("memoryBankV2.domain") }}</p>
              <el-select v-model="formLabelAlign.domain_code"
                         :placeholder="$t('memoryBankV2.pleaseChoose')" @change="changeTerritory"
                         clearable @clear="clearTerritory">
                <el-option v-for="(item, index) in territory" :key="index" :label="item.name"
                           :value="item.code"></el-option>
              </el-select>
            </div>
          </div>
          <div class="top_right">
            {{$t('memoryBankV2.Selected')}} <em>{{newarr.length}}</em>
            {{bankType==='memory'?$t('memoryBankV2.individualMemory'):$t('memoryBankV2.individualTerm')}}
          </div>
        </div>
        <!--下拉框和搜索框结束  -->
        <!-- 表格 -->
        <div
             :class="formLabelAlign.lang_desc&&formLabelAlign.domain_code?'memoryMerge_content_main':'memoryMerge_content_empty'">
          <template v-if="formLabelAlign.lang_desc&&formLabelAlign.domain_code">
            <el-table ref="multipleTable" height="100%" :data="tableList" border
                      @selection-change="handleSelectionChange">
              <el-table-column type="selection" width="40" align="center" />
              <el-table-column type="index" :index="indexMethod" :label="$t('memoryBankV2.number')"
                               width="57" align="center" :show-overflow-tooltip="true" />
              <el-table-column prop="name" :label="$t('memoryBankV2.mergeLibraryName')" width="235"
                               align="center" :show-overflow-tooltip="true">
                <template slot-scope="scope">
                  <!-- <div class="fileName_box">
                  
                  </div> -->
                  <p class="name_active" style="cursor: pointer" @click="handlerView(scope.row)">
                    {{ scope.row.name }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="langDesc"
                               :label="$t('memoryBankV2.languageDirectionNoColon')" align="center">
                <template slot-scope="{ row }">
                  {{
                  $i18n.locale === "zh"
                    ? row.langDesc.replace('>'," — ")
                    : $langCase[row.sourceLang] +
                      " — " +
                      $langCase[row.targetLang]
                }}
                </template>
              </el-table-column>

              <el-table-column :show-overflow-tooltip="true" prop="domainName"
                               :label="$t('memoryBankV2.domainNoColon')" align="center">
                <template slot-scope="{ row }">
                  {{
                  $i18n.locale === "zh"
                    ? row.domainName
                    : $domainCase[row.domainCode]
                }}
                </template>
              </el-table-column>

              <el-table-column prop="sentCount" :label="$t('memoryBankV2.sentenceNum')"
                               align="center" />
              <el-table-column prop="viewDetail" :label="$t('projectDetailsV2.preview')"
                               align="center" width="60px">
                <template slot-scope="{row}">
                  <span class="view" @click="handlerView(row)"></span>
                </template>
              </el-table-column>
            </el-table>
          </template>
          <template v-else>
            <div class="empty-list">
              {{bankType==='memory'?$t("memoryBankV2.OnlythesamelanguagedirectionissupportedandthedomainmemoryismergedPleaseselect"):
              $t('memoryBankV2.OnlythesamelanguagedirectionissupportedPleaseselect')}}
            </div>
          </template>
        </div>
        <!-- 表格结束 -->
        <div class="memoryMerge_content_footer">
          <p class="mergeSet">{{$t('memoryBankV2.MergeSettings')+" :"}}</p>
          <p class="mergeName">
            {{ bankType==='memory'?$t("memoryBankV2.newmemoryname"):$t('memoryBankV2.newtermbasename') }}
          </p>
          <el-input :placeholder="$t('memoryBankV2.Pleaseenterthenameofthemergedlibrary')"
                    v-model.trim="catname" type="text"></el-input>
          <div class="mergePattern">
            <p>
              {{ bankType==='memory'?$t("memoryBankV2.Whethertokeepthememorybeforemerging"):$t('memoryBankV2.Whethertokeepthememorybeforemerging') }}
            </p>
            <el-radio-group v-model="radio" size="small">
              <el-radio label="0" class="radio_left">{{
             $t("memoryBankV2.retain")
            }}</el-radio>
              <el-radio label="-1" class="radio_right">{{
            $t("memoryBankV2.Abandonment")
            }}</el-radio>
            </el-radio-group>
          </div>
        </div>

      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleClose">{{
          $t("memoryBankV2.cancel")
        }}</el-button>
        <el-button v-preventReClick class="merge" type="primary" @click="Merge">
          {{ $t("memoryBankV2.merge") }}</el-button>
      </span>
    </el-dialog>
    <!-- 合并成功弹窗 -->
    <mergesuccess-dialog :mergeSuccessVisible="mergeSuccessVisible" @handleClose="closemergeSuccess"
                         :bankType="bankType" @handlerDetail="handlrmergesDetail">

    </mergesuccess-dialog>
  </div>
</template>

<script>
// 标题组件
import DialogsHeader from '@/common/dialogsHeader';
import { mergeMemory, getMemory } from "@/services/memoryBank"
import { mergeTerm, getTermList } from "@/services/term";
import debounce from "lodash.debounce";
//合并成功
import mergesuccessDialog from "../components/mergesuccessDialog"
export default {
  name: "memoryMerge", //记忆库合并
  props: {
    mergeVisible: {
      type: Boolean,
    },
    languageTwain: {
      //语言列表数据
      type: Array,
      required: true
    },
    territory: {
      //领域数据
      type: Array,
      required: true
    },
    bankType: {
      type: String,
      required: true
    }
  },
  components: {
    DialogsHeader,
    mergesuccessDialog,
  },
  data() {
    return {
      formLabelAlign: {
        domain_code: "",
        lang_desc: "",
        name: "",
      },
      radio: "0",
      newarr: [], //选中数据
      catname: "", //合并记忆库名称
      idList: [],//选中的id
      tableList: [],//列表数据
      param: {
        page: 1,
        rows: 10
      },
      totalPage: 0,
      mergeSuccessVisible: false,//合并成功弹窗
      mergesInfo: {}
    };
  },

  mounted() {

  },
  methods: {
    //格式化index
    indexMethod(index) {
      if (index < 9) {
        index += 1;
        return "0" + index;
      } else {
        return index + 1;
      }
    },
    //跳转详情
    handlerView(row) {
      const routeData = this.$router.resolve({
        name: this.bankType === 'memory' ? 'wareMemoryDetail' : 'wareTermbankDetail',
        query: {
          key: this.$Base64.encode(JSON.stringify({
            row,
            type: 'corpus',
            langList: this.langList,
            optionList: this.optionList
          }))
        }
      });
      window.open(routeData.href, "_blank");
    },
    //不能以空格开头
    changeinput() {
      this.formLabelAlign.name = this.formLabelAlign.name.replace(/^\s*/g, '');
    },
    async Merge() {
      //合并按钮

      if (this.catname.length > 16) {
        this.$message.closeAll()
        this.$message.error(this.$t('memoryBankV2.mergeNameLength'))
        return
      }
      if (this.formLabelAlign.lang_desc === '') {
        this.$message.closeAll();
        this.$message.warning(this.$t("newProjectV2.langPairTip"));
        return
      }
      if (this.formLabelAlign.domain_code === '') {
        this.$message.closeAll();
        this.$message.warning(this.$t("newProjectV2.domainTip"));
        return
      }
      if (this.newarr.length < 2) {
        this.$message.closeAll();
        this.$message.warning(this.$t("memoryBankV2.Pleasecheckthecorpustobemerged"));
        return
      }
      if (this.catname.trim() === '') {
        this.$message.closeAll();
        this.$message.warning(this.$t("memoryBankV2.Pleaseenterthenameofthemergedlibrary"));
        return
      }
      const params = {
        name: this.catname,
        deleteStatus: this.radio,
        domainCode: this.formLabelAlign.domain_code,
        langDesc: this.formLabelAlign.lang_desc,
        creatorId: localStorage.userInfo.userId,
        idList: this.idList,
        domainName: this.newarr[0].domainName,
        sourceLang: this.newarr[0].sourceLang,
        targetLang: this.newarr[0].targetLang
      };
      let data = {};
      if (this.bankType === 'memory') {
        const { result, success } = await mergeMemory(params)
        if (success) {
          data = result;
          this.$emit("handleConfirm");
          this.mergeSuccessVisible = true;
          this.mergesInfo = data
          this.handlerinitData();
          this.tableList = []
        }
      } else {
        const { result, success } = await mergeTerm(params)
        if (success) {
          data = result;
          this.$emit("handleConfirm");
          this.mergeSuccessVisible = true;
          this.mergesInfo = data
          this.handlerinitData();
          this.tableList = []
        }
      }

    },
    //关闭合并成功弹窗
    closemergeSuccess() {
      this.handlerinitData();
      this.mergeSuccessVisible = false;
    },
    //合并成功去查看
    handlrmergesDetail() {
      const routeData = this.$router.resolve({
        name: this.bankType === 'memory' ? 'wareMemoryDetail' : 'wareTermbankDetail',
        query: {
          key: this.$Base64.encode(JSON.stringify({
            row: this.mergesInfo,
            type: 'corpus',
            langList: this.langList,
            optionList: this.optionList
          }))
        }
      });
      window.open(routeData.href, "_blank");
      this.mergeSuccessVisible = false;
    },
    //关闭弹窗
    handleClose() {
      this.$emit("handlerclose");
      this.handlerinitData();
      this.tableList = [];
    },
    //初始化数据
    handlerinitData() {
      this.formLabelAlign.domain_code = "";
      this.formLabelAlign.lang_desc = "";
      this.formLabelAlign.name = "";
      this.radio = "0";
      this.catname = "";
      this.param.page = 1;
      this.$refs.multipleTable && this.$refs.multipleTable.clearSelection();
    },
    async gettableList(domain_code, lang_desc) {
      let params = {
        filter: {
          domain_code,
          lang_desc,
          queryType: "1",
        },
        page: this.param.page,
        rows: this.param.rows,
      }
      if (this.bankType === 'memory') {
        const { list, totalPage, success } = await getMemory(params);
        if (success) {
          this.totalPage = totalPage;
          this.tableList = [...this.tableList, ...list]
        }
      } else {
        const { list, totalPage, success } = await getTermList(params);
        if (success) {
          this.totalPage = totalPage;
          this.tableList = [...this.tableList, ...list]
        }
      }
    },
    //切换语言
    changeLanguage() {
      if (this.formLabelAlign.lang_desc && this.formLabelAlign.domain_code) {
        this.param.page = 1;
        this.tableList.length = 0;
        this.gettableList(this.formLabelAlign.domain_code, this.formLabelAlign.lang_desc);
        this.$nextTick(() => {
          const tableWrapper = this.$refs.multipleTable.bodyWrapper
          tableWrapper && tableWrapper.addEventListener('scroll', debounce(this.handlerScroll, 1000))
        })
      }
    },
    //切换领域
    changeTerritory() {
      if (this.formLabelAlign.lang_desc && this.formLabelAlign.domain_code) {
        this.param.page = 1;
        this.tableList.length = 0;
        this.gettableList(this.formLabelAlign.domain_code, this.formLabelAlign.lang_desc);
        this.$nextTick(() => {
          const tableWrapper = this.$refs.multipleTable.bodyWrapper
          tableWrapper && tableWrapper.addEventListener('scroll', debounce(this.handlerScroll, 1000))
        })
      }
    },
    handlerScroll() {
      const tableWrapper = this.$refs.multipleTable.bodyWrapper
      let scrollTop = tableWrapper.scrollTop
      // 变量windowHeight是可视区的高度
      let windowHeight = tableWrapper.clientHeight || tableWrapper.clientHeight
      // 变量scrollHeight是滚动条的总高度
      let scrollHeight = tableWrapper.scrollHeight || tableWrapper.scrollHeight
      if (scrollTop + windowHeight === scrollHeight) {
        this.param.page++;
        if (this.param.page > this.totalPage) {
          return
        }
        this.gettableList(this.formLabelAlign.domain_code, this.formLabelAlign.lang_desc);
      }
    },
    handleSelectionChange(val) {
      //选中数据
      this.newarr = val;
      this.idList = val.map((item) => {
        return item.id;
      });
    },
    clearLanguage() {
      //清空选择语言
      this.formLabelAlign.lang_desc = "";
    },
    clearTerritory() {
      //清空选择领域
      this.formLabelAlign.domain_code = "";
    },
    // toEditor(row) {
    //   //进入详情
    //   this.$router.push({
    //     name: this.bankType === 'memory' ? 'memoryDetail' : 'termbankDetail',
    //     query: {
    //       key: this.$Base64.encode(JSON.stringify({
    //         row,
    //         langList: this.langList,
    //         optionList: this.optionList
    //       }))
    //     }
    //   });
    // },
  },
};
</script>

<style lang="less" scoped>
// @import "./assets/style.less";
.memoryMerge {
  @media (max-width: 1280px) {
    /deep/.el-dialog {
      // height: 500px !important;
      .memoryMerge_content_main {
        height: 190px !important;
      }
      .el-dialog__body {
        height: calc(100% - 50px) !important;
      }
      .mergeSet {
        margin: 10px 0px !important;
      }
      .mergePattern {
        margin: 10px 0px !important;
      }
    }
  }
  /deep/.el-dialog__wrapper {
    overflow: visible;
  }
  /deep/ .el-table {
    border-radius: 4px;
    .el-table__header th {
      padding: 0;
      font-size: 14px;
      font-weight: bold;
      color: #566087;
      background: #e4edfc;
      &:first-child .cell {
        padding-right: 14px;
      }
    }
  }
  /deep/ .popupBox {
    box-sizing: border-box;
    width: 789px;
    border-radius: 12px;
    padding: 12px 32px;
    position: absolute;
    top: 50%;
    left: 50%;
    margin: 0 !important;
    transform: translate(-50%, -50%);
    .el-dialog__header {
      padding: 0;
    }
    .el-dialog__body {
      padding: 0;
      height: calc(100% - 42px);
    }
    .memoryMerge_content {
      box-sizing: border-box;
      margin-top: 20px;
      width: 100%; // height: 290px; // padding: 0 26px;
      .memoryMerge_content_top {
        width: 100%;
        height: 32px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .top_left {
          display: flex;
          justify-content: space-between;
          .language {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
          .territory {
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        .top_left {
          .language {
            .el-select {
              margin-left: 6px;
              .el-input,
              .el-input__inner {
                width: 136px;
                height: 32px;
                line-height: 31px;
                &::placeholder {
                  line-height: 31px;
                }
                .el-input__icon {
                  line-height: 32px;
                }
              }
            }
          }
          .territory {
            margin-left: 20px;
            .el-select {
              margin-left: 6px;
              .el-input,
              .el-input__inner {
                width: 136px;
                height: 32px;
                line-height: 31px;
                &::placeholder {
                  line-height: 31px;
                }
                .el-input__icon {
                  line-height: 32px;
                }
              }
            }
          }
        }
        .top_right {
          width: 240px;
          height: 32px;
          position: relative;
          text-align: right;
          .el-input {
            .el-input__inner {
              float: left;
              width: 194px;
              height: 32px;
              border-radius: 4px 0 0 4px;
              border-right: none;
              line-height: 31px;
              &::placeholder {
                line-height: 31px;
              }
            }
            .el-input__suffix {
              top: -2px;
              right: 60px;
            }
          }
          em {
            color: #0078fc;
          }
          .search_btn {
            position: absolute;
            right: 0;
            top: 0;
            display: inline-block;
            width: 60px;
            height: 30px;
            text-align: center;
            line-height: 30px;
            background: #0078fc;
            border: 1px solid #0078fc;
            color: #fff;
            border-radius: 0px 4px 4px 0px;
            cursor: pointer;
          }
          .el-input__suffix {
            position: absolute;
            top: -4px;
            right: 50px;
          }
        }
      }
      .memoryMerge_content_empty {
        margin-top: 20px;
        width: 100%;
        height: 100%;
        .empty-list {
          width: 100%;
          height: 100px;
          line-height: 100px;
          text-align: center;
          background: #f5f7fa;
        }
      }
      .memoryMerge_content_main {
        margin-top: 20px;
        width: 100%;
        height: 340px;
        .el-table__body td {
          height: 30px;
          .view {
            display: inline-block;
            width: 16px;
            height: 16px;
            background: url("../images/preview.png") no-repeat;
            cursor: pointer;
            &:hover {
              background: url("../images/preview_pre.png") no-repeat;
            }
          }
        }
        .el-table__cell {
          padding: 8px 0;
        }
        .el-table__empty-block {
          min-height: 100px;
        }
        .name_active {
          display: inline-block;
          width: 100%;
          font-size: 14px;
          font-weight: 400;
          color: #63adff;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          &:hover {
            text-decoration: underline;
          }
        }
      }
      .mergePattern {
        margin: 20px 0px 24px 0px;
        display: flex;
        align-items: center;
        height: 14px;
        font-size: 14px;
        color: #666;
        p {
          text-align: left;
          height: 20px;
          line-height: 18px;
        }
        .radio_left {
          margin: 0 26px 0 12px;
        }
        .el-radio {
          .el-radio__inner {
            margin-bottom: 1px;
            width: 12px;
            height: 12px;
          }
          .el-radio__input {
            &.is-checked {
              .el-radio__inner {
                margin-bottom: 1px;
                width: 12px;
                height: 12px;
                &::after {
                  background: #0078fc;
                }
              }
            }
          }
          .el-radio__label {
            padding-left: 6px;
          }
        }
      }
      .memoryMerge_content_footer {
        height: 142px;
        .mergeSet {
          width: 100%;
          margin: 25px 0 20px 0;
          font-size: 14px;
          font-weight: bold;
          color: #909399;
        }
        .mergeName {
          position: relative;
          float: left;
          font-size: 14px;
          font-weight: 400;
          color: #666;
          text-align: left;
          margin-right: 12px;
          &::after {
            position: absolute;
            top: 0;
            left: -8px;
            content: "*";
            font-size: 16px;
            color: #f56c6c;
          }
        }

        .el-input {
          width: 424px;
          .el-input__inner {
            width: 100%;
            height: 32px;
            line-height: 31px;
            &::placeholder {
              line-height: 31px;
            }
          }
        }
      }
    }
    .el-button {
      width: 76px;
      height: 32px;
      padding: 0;
      border-radius: 4px;
    }
    .el-button--default {
      border: 1px solid #0078fc;
      color: #0078fc;
    }
    .el-button + .el-button {
      margin-left: 30px;
    }
  }
}
</style>
